import { useState, useEffect, useContext } from 'react'
import axios from 'axios'
import { Box } from '@mui/material'
import Header from './Header'
import Main from './Main'
import { PageContextProvider, ThemeContextProvider, ReportContextProvider, UserContext, ThemeContext, PageContext } from '../Context'
import { AppThemeWrapper } from '../ThemeWrapper'

// Composant qui gère l'attribut data-theme sur le body
function ThemeBodyAttributeManager({ children }) {
  const { theme } = useContext(ThemeContext);

  useEffect(() => {
    // Appliquer l'attribut data-theme au body
    document.body.setAttribute('data-theme', theme);
    
    // Nettoyer à la destruction du composant
    return () => {
      document.body.removeAttribute('data-theme');
    };
  }, [theme]);

  return children;
}

// Composant qui gère le chargement de la préférence de thème
function ThemeLoader({ children }) {
  const { user } = useContext(UserContext);
  const { setInitialTheme } = useContext(ThemeContext);
  const [themeLoaded, setThemeLoaded] = useState(false);

  useEffect(() => {
    const loadUserThemePreference = async () => {
      if (user) {
        try {
          const token = sessionStorage.getItem('authToken');
          const config = {
            headers: { Authorization: `Bearer ${token}` }
          };

          const response = await axios.get('/api/user', config);
          const currentUser = response.data.find(u => u.matricule === user);
          
          if (currentUser && currentUser.themePreference) {
            setInitialTheme(currentUser.themePreference);
          }
        } catch (err) {
          console.error('Erreur lors du chargement de la préférence de thème:', err);
          // En cas d'erreur, utiliser le thème par défaut (light)
        }
      }
      setThemeLoaded(true);
    };

    loadUserThemePreference();
  }, [user, setInitialTheme]);

  // Attendre que le thème soit chargé avant d'afficher le contenu
  if (!themeLoaded) {
    return null; // ou un loader si souhaité
  }

  return children;
}

function PostCguLandingManager() {
  const { setPage } = useContext(PageContext);

  useEffect(() => {
    const postCguLanding = sessionStorage.getItem('postCguLanding');
    if (postCguLanding === 'tutorial') {
      setPage('Tutorial');
      sessionStorage.removeItem('postCguLanding');
    }
  }, [setPage]);

  return null;
}

//Composant qui affiche toute la page principale de l'app, décomposé en header, footer mais surtout left, central et right. Etant à la source, il reprend des useState (hooks).
function Connected() {
  return (
    <ReportContextProvider>
      <ThemeContextProvider>
        <PageContextProvider>
          <ThemeLoader>
            <ThemeBodyAttributeManager>
              <AppThemeWrapper>
                <PostCguLandingManager />
                <Box sx={{ 
                  display: 'flex', 
                  flexDirection: 'column', 
                  minHeight: '100vh'
                }}>
                  <Header />
                  <Box sx={{ 
                    flex: 1, 
                    minHeight: 'calc(100vh - 6.5vh)',
                    overflow: 'auto'
                  }}>
                    <Main />
                  </Box>
                </Box>
              </AppThemeWrapper>
            </ThemeBodyAttributeManager>
          </ThemeLoader>
        </PageContextProvider>
      </ThemeContextProvider>
    </ReportContextProvider>
  );
}

export default Connected